webpackJsonp([15],{

/***/ 714:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_MetaDecorator__ = __webpack_require__(722);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__media_images_sharepoint_jpg__ = __webpack_require__(878);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__media_images_sharepoint_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__media_images_sharepoint_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__media_images_sharepointMobile_jpg__ = __webpack_require__(879);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__media_images_sharepointMobile_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__media_images_sharepointMobile_jpg__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SharePoint=function(_Component){_inherits(SharePoint,_Component);function SharePoint(props){_classCallCheck(this,SharePoint);var _this=_possibleConstructorReturn(this,(SharePoint.__proto__||Object.getPrototypeOf(SharePoint)).call(this,props));_this.componentDidMount=function(){var tabs=document.getElementsByClassName("nav-wrapper");if(tabs.length>0){tabs=tabs[1].querySelectorAll("ul")[0].querySelectorAll("a");for(var i=0;i<tabs.length;i++){tabs[i].removeAttribute("class");if(tabs[i].id==="scopes"||tabs[i].id==="sharepoint"){tabs[i].setAttribute("class","orange-text text-darken-4");}}}var mobileTabs=document.getElementsByClassName("sidenav");if(mobileTabs.length>0){mobileTabs=mobileTabs[0].querySelectorAll("a");for(var _i=0;_i<mobileTabs.length;_i++){if(mobileTabs[_i].id==="scopesMobile"||mobileTabs[_i].id==="sharepointMobile"){mobileTabs[_i].removeAttribute("class");mobileTabs[_i].setAttribute("class","orange-text text-darken-4 grey darken-3");}}}_this.updateWindowDimensions();window.addEventListener("resize",_this.updateWindowDimensions.bind(_this));};_this.updateWindowDimensions=function(){_this.setState({width:window.innerWidth});};_this.state={width:window.innerWidth};return _this;}_createClass(SharePoint,[{key:"render",value:function render(){var width=this.state.width;var isMobile=width<=600;var isTablet=width<=992&&width>600;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__services_MetaDecorator__["a" /* default */],{title:"JetMinds | SharePoint Dienstleister, Beratung, Konzeption und Entwicklung",descrption:"Moderne L\xF6sungen, die wir mit SharePoint Online f\xFCr Ihr Firma erstellen k\xF6nnen: Intranet, Dokumentbibliotheken, Datenbanken, Kalender- und Eventlisten, Websites und vieles mehr",url:"https://www.jetminds.de/fokusbereiche/sharepoint-online/"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"pageImageTitle"},isMobile?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{className:"responsive-img",style:{width:"100%"},src:__WEBPACK_IMPORTED_MODULE_3__media_images_sharepointMobile_jpg___default.a,alt:"JetMinds SharePoint Online",loading:"lazy"}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{className:"responsive-img",style:{width:"100%"},src:__WEBPACK_IMPORTED_MODULE_2__media_images_sharepoint_jpg___default.a,alt:"JetMinds SharePoint Online",loading:"lazy"}),isMobile||isTablet?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"imgTxtMobile"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h1",{className:"white-text "+(isTablet?"isTablet":"isMobile")},"SharePoint Online")):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"imgTxt"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h1",{className:"white-text"},"SharePoint Online"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"container"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"section"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"row"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col s12 m12"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h1",{className:""+(isMobile?"pageTitleM":"pageTitle")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"orange-text text-darken-4"},"Stabile")," ","Zusammenarbeit,"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"orange-text text-darken-4"},"moderne")," UI und leistungsstarke Funktionen basierend auf"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"orange-text text-darken-4"},"SharePoint Online")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"row"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col s12 m12"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"light"},"Unsere Mission als End-to-End Dienstleister f\xFCr moderne Informationstechnologie und digitale Transformation ist es Unternehmen und Organisationen zu erm\xF6glichen, mehr mit der Digitalisierung zu erreichen. Um dies zu realisieren, haben wir unsere Entscheidung mit voller \xDCberzeugung getroffen, Microsoft SharePoint Online zu verwenden, um Unternehmen dabei zu helfen, ihre digitalen Anforderungen zu erf\xFCllen."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"light"},"SharePoint Online ist nicht nur ein Dokumentenmanagementsystem (DMS) sondern es ist die Plattform, die allen Arten von Organisationen und Unternehmen beeindruckende Content-Erlebnisse und Teamwork-Services bietet. Es gibt die M\xF6glichkeit, Inhalte, Dateien und Listen intern sowie extern mit Partnern und Anbietern auszutauschen. Zus\xE4tzlich steht eine breite Palette von Diensten wie Websites, Dokumentbibliotheken, Ereignislisten, Nachrichten, Dashboards und viele andere n\xFCtzliche Dienste bereit."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"light"},"SharePoint gibt es seit 2001 und wurde im Laufe der Zeit kontinuierlich verbessert, sodass wir mit SharePoint Online jetzt eine Version haben, die modern, leistungsstark und sofort in der Cloud einsatzbereit ist. Hier haben wir Ihnen einige der Highlights von SharePoint Online aufgelistet:"))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"grey darken-3"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"container"},!isMobile&&!isTablet?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"section"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"row center"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col s6 m3"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"icon-block"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2",{className:"center white-text text-darken-4"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"material-icons",style:{fontSize:"35px"}},"cloud_done")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"light white-text"},"Cloud-basierte Plattform ohne Installation, physische Vorbereitungen oder Hardware"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col s6 m3"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"icon-block"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2",{className:"center white-text text-darken-4"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"material-icons",style:{fontSize:"35px"}},"euro_symbol")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"light white-text"},"Reduzierte Startkosten, da keine zus\xE4tzlichen Infrastrukturzahlungen anfallen"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col s6 m3"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"icon-block"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2",{className:"center white-text text-darken-4"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"material-icons",style:{fontSize:"35px"}},"system_update_alt")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"light white-text"},"Immer auf dem neuesten Stand, keine Updates und Patches erforderlich"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col s6 m3"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"icon-block"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2",{className:"center white-text text-darken-4"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"material-icons",style:{fontSize:"35px"}},"color_lens")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"light white-text"},"Modernes Branding in einer responsiven Umgebung mit flexiblen Templates")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"row center"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col s6 m3"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"icon-block"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2",{className:"center white-text text-darken-4"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"material-icons",style:{fontSize:"35px"}},"library_books")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"light white-text"},"Sehr gut konzipierte und erweiterbare Bibliotheken und Listen mit Metadaten"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col s6 m3"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"icon-block"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2",{className:"center white-text text-darken-4"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"material-icons",style:{fontSize:"35px"}},"share")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"light white-text"},"Die M\xF6glichkeit Daten sowohl intern als auch extern freizugeben"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col s6 m3"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"icon-block"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2",{className:"center white-text text-darken-4"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"material-icons",style:{fontSize:"35px"}},"search")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"light white-text"},"Eine sehr leistungsstarke, \xFCbergreifende und performante Suchmaschine"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col s6 m3"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"icon-block"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2",{className:"center white-text text-darken-4"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"material-icons",style:{fontSize:"35px"}},"web")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"light white-text"},"Sehr leistungsf\xE4hige Plattform zur Erstellung von internen Websites"))))):"",isMobile?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"section"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"row center"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col s6"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"icon-block"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2",{className:"center white-text text-darken-4"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"material-icons",style:{fontSize:"35px"}},"cloud_done")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"light white-text"},"Cloud-basierte Plattform ohne Installation, physische Vorbereitungen oder Hardware"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col s6"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"icon-block"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2",{className:"center white-text text-darken-4"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"material-icons",style:{fontSize:"35px"}},"euro_symbol")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"light white-text"},"Reduzierte Startkosten, da keine zus\xE4tzlichen Infrastrukturzahlungen anfallen")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"row center"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col s6"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"icon-block"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2",{className:"center white-text text-darken-4"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"material-icons",style:{fontSize:"35px"}},"system_update_alt")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"light white-text"},"Immer auf dem neuesten Stand, keine Updates und Patches erforderlich"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col s6"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"icon-block"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2",{className:"center white-text text-darken-4"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"material-icons",style:{fontSize:"35px"}},"color_lens")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"light white-text"},"Modernes Branding in einer responsiven Umgebung mit flexiblen Templates")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"row center"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col s6"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"icon-block"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2",{className:"center white-text text-darken-4"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"material-icons",style:{fontSize:"35px"}},"library_books")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"light white-text"},"Sehr gut konzipierte und erweiterbare Bibliotheken und Listen mit Metadaten"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col s6"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"icon-block"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2",{className:"center white-text text-darken-4"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"material-icons",style:{fontSize:"35px"}},"share")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"light white-text"},"Die M\xF6glichkeit Daten sowohl intern als auch extern freizugeben")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"row center"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col s6"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"icon-block"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2",{className:"center white-text text-darken-4"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"material-icons",style:{fontSize:"35px"}},"search")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"light white-text"},"Eine sehr leistungsstarke, \xFCbergreifende und performante Suchmaschine"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col s6"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"icon-block"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2",{className:"center white-text text-darken-4"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"material-icons",style:{fontSize:"35px"}},"web")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"light white-text"},"Sehr leistungsf\xE4hige Plattform zur Erstellung von internen Websites"))))):"",isTablet?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"section"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"row center"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col s6 m4"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"icon-block"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2",{className:"center white-text text-darken-4"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"material-icons",style:{fontSize:"35px"}},"cloud_done")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"light white-text"},"Cloud-basierte Plattform ohne Installation, physische Vorbereitungen oder Hardware"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col s6 m4"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"icon-block"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2",{className:"center white-text text-darken-4"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"material-icons",style:{fontSize:"35px"}},"euro_symbol")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"light white-text"},"Reduzierte Startkosten, da keine zus\xE4tzlichen Infrastrukturzahlungen anfallen"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col s6 m4"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"icon-block"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2",{className:"center white-text text-darken-4"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"material-icons",style:{fontSize:"35px"}},"system_update_alt")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"light white-text"},"Immer auf dem neuesten Stand, keine Updates und Patches erforderlich")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"row center"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col s6 m4"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"icon-block"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2",{className:"center white-text text-darken-4"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"material-icons",style:{fontSize:"35px"}},"color_lens")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"light white-text"},"Modernes Branding in einer responsiven Umgebung mit flexiblen Templates"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col s6 m4"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"icon-block"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2",{className:"center white-text text-darken-4"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"material-icons",style:{fontSize:"35px"}},"library_books")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"light white-text"},"Sehr gut konzipierte und erweiterbare Bibliotheken und Listen mit Metadaten"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col s6 m4"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"icon-block"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2",{className:"center white-text text-darken-4"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"material-icons",style:{fontSize:"35px"}},"share")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"light white-text"},"Die M\xF6glichkeit Daten sowohl intern als auch extern freizugeben")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"row center"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col s6 m4"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"icon-block"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2",{className:"center white-text text-darken-4"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"material-icons",style:{fontSize:"35px"}},"search")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"light white-text"},"Eine sehr leistungsstarke, \xFCbergreifende und performante Suchmaschine"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col s6 m4"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"icon-block"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2",{className:"center white-text text-darken-4"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"material-icons",style:{fontSize:"35px"}},"web")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"light white-text"},"Sehr leistungsf\xE4hige Plattform zur Erstellung von internen Websites"))))):"")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"container"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"section"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"row"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col s12 m12"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h5",null,"Unsere"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"orange-text text-darken-4"},"Servicepalette")," ","im Bereich Microsoft"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"orange-text text-darken-4"},"SharePoint Online")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"row"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col s12 m12"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"light"},"Wenn es um das Thema SharePoint Online-Plattform geht, sind wir mit Herz und Verstand bei der Sache. Unsere ausgiebige Beratung beantwortet Ihre Fragen und unsere umfassenden Dienstleistungen erf\xFCllen Ihre speziellen Anforderungen. Durch umfangreiche und erfolgreiche Projekte im Bereich SharePoint Online haben wir praktische Erfahrungen gesammelt und ein breites Verst\xE4ndnis f\xFCr die Themen, die f\xFCr die meisten Unternehmen wichtig sind, erworben:")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col s12 "+(isTablet?"m12":"m4")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"icon-block"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2",{className:"center orange-text text-darken-4"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"material-icons",style:{fontSize:"35px"}},"business")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h5",{className:"center"},"Beratung"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"light"},"Sie befinden sich in der Planungsphase vor Ihrem n\xE4chsten Schritt zum modernen Arbeitsplatz und zur digitalen Zusammenarbeit basierend auf SharePoint Online. Haben Sie hierzu offene Fragen? Geht es um Integration, Migration, Sicherheit, Provisionierung, Administration, Entwicklung oder Konfiguration? Wir stehen Ihnen mit fundierter technischer sowie funktioneller Beratung rund um das Thema SharePoint Online zur Seite."))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col s12 "+(isTablet?"m12":"m4")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"icon-block"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2",{className:"center orange-text text-darken-4"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"material-icons",style:{fontSize:"35px"}},"code")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h5",{className:"center"},"Entwicklung"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"light"},"Wir bieten Ihnen individuelle SharePoint Online Add-Ins basierend auf Ihren Anforderungen. Wir sind der festen \xDCberzeugung, dass jedes Unternehmen eine einzigartige SharePoint Solution, die seinen Bed\xFCrfnissen entspricht, verdient. Deshalb beschr\xE4nken wir unsere Arbeit nie auf die Anpassung von Out-of-the-Box-Funktionen, sondern bieten ma\xDFgeschneiderte Webparts, Branding, Architektur, Workflows oder ein vollst\xE4ndiges Intranet an."))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col s12 "+(isTablet?"m12":"m4")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"icon-block"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2",{className:"center orange-text text-darken-4"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"material-icons",style:{fontSize:"35px"}},"sync")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h5",{className:"center"},"Migration"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"light"},"Wir helfen Ihnen bei Ihrem Wechsel zu SharePoint Online und OneDrive in Microsoft 365. Es gibt verschiedene Tools und Methoden, die wir bei der Migration verwenden k\xF6nnen. Was f\xFCr Ihre Organisation am besten geeignet ist, h\xE4ngt von einer Reihe Faktoren ab: Die Datengr\xF6\xDFe, die Menge, die Inhalte, die Datenquelle usw. Der Schl\xFCssel zu einer erfolgreichen Migration ist die Planung einschlie\xDFlich der Inventarisierung und Bewertung Ihrer Daten.")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"row"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col s12 "+(isTablet?"m12":"m4")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"icon-block"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2",{className:"center orange-text text-darken-4"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"material-icons",style:{fontSize:"35px"}},"power")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h5",{className:"center"},"Support und Wartung"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"light"},"Durch unsere mehrj\xE4hrige Erfahrung mit SharePoint Online k\xF6nnen wir Ihre gew\xFCnschten Anforderungen verwirklichen. Jedoch kann unsere Zusammenarbeit weiter gef\xFChrt werden durch unsere umfassenden Support- und Wartungsleistungen. Wir kontrollieren kontinuierlich Ihre SharePoint Online Umgebung und gew\xE4hrleisten so eine robuste und fehlerfreie Plattform f\xFCr die Kollaboration und Kommunikation."," "))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col s12 "+(isTablet?"m12":"m4")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"icon-block"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2",{className:"center orange-text text-darken-4"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"material-icons",style:{fontSize:"35px"}},"import_export")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h5",{className:"center"},"Integration"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"light"},"Ein erfolgreicher, moderner Arbeitsplatz basierend auf SharePoint Online, der mit den neuesten Technologien ausgestattet ist, l\xE4sst sich mit Daten von anderen Microsoft-Plattformen oder Drittanbietern problemlos integrieren. Wir \xFCbernehmen alle Datenintegrationen und die damit verbundenen Datenarchitekturen auf Basis von SharePoint Online, um Ihnen die Integration in Ihre SharePoint Online-Plattform zu verwirklichen."))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col s12 "+(isTablet?"m12":"m4")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"icon-block"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2",{className:"center orange-text text-darken-4"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"material-icons",style:{fontSize:"35px"}},"done_all")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h5",{className:"center"},"Health Check"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"light"},"Ihre SharePoint Online-Plattform sollte immer performant und fehlerfrei sein. Wenn nicht, sollten Sie das nicht ignorieren. Selbst geringf\xFCgige Probleme k\xF6nnen Ihre SharePoint-Plattform besch\xE4digen und dazu f\xFChren, dass ein benutzerfreundliches, reibungsloses Arbeiten nicht mehr m\xF6glich ist. Wir bieten Ihnen den SharePoint Health Check sowie Troubleshooting und Monitoring an, um die Effizienz Ihrer Plattform zu analysieren.")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"row"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col s12 "+(isTablet?"m12":"m4")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"icon-block"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2",{className:"center orange-text text-darken-4"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"material-icons",style:{fontSize:"35px"}},"touch_app")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h5",{className:"center"},"Provisionierung"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"light"},"Da Arbeitsbereiche auf unterschiedliche Weise und an unterschiedlichen Standorten erstellt werden k\xF6nnen, kann dies schnell au\xDFer Kontrolle geraten. Die Provisionierung bezieht sich hier auf die automatische Erstellung und Konfiguration von Arbeitsbereichen anstelle einer Person, die die gesamte Arbeit manuell ausf\xFChrt. Unter Arbeitsbereichen verstehen wir Orte f\xFCr die digitale Zusammenarbeit, z. B. SharePoint Online-Websites, Microsoft 365 Gruppen sowie"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{className:"orange-text text-darken-4",href:"/fokusbereiche/microsoft-teams"},"Teams")," ","und TeamSites."))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col s12 "+(isTablet?"m12":"m4")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"icon-block"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2",{className:"center orange-text text-darken-4"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"material-icons",style:{fontSize:"35px"}},"security")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h5",{className:"center"},"Administration"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"light"},"Nur mit einer guten Administration k\xF6nnen kleine, mittelst\xE4ndige sowie gro\xDFe Unternehmen \xFCber ein eigenes Unternehmensintranet verf\xFCgen. Die Administration von SharePoint Online-Plattform soll die Zusammenarbeit erleichtern und gew\xE4hrleisten. Ihre Benutzer sollten in der Lage sein, Dokumente, Kalender, Listen, Bilder, Diskussionsforen und mehr, f\xFCr Benutzer in Ihrem Netzwerk und in einigen F\xE4llen f\xFCr Personen au\xDFerhalb Ihres Netzwerks, wie Partner oder Vendors, freizugeben."))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col s12 "+(isTablet?"m12":"m4")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"icon-block"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2",{className:"center orange-text text-darken-4"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"material-icons",style:{fontSize:"35px"}},"settings")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h5",{className:"center"},"Konfiguration"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"light"},"Das Einrichten und Konfigurieren von SharePoint Online Tenant mit den Best Practices beginnt, sobald Sie sich f\xFCr Microsoft 365 Tenant anmelden. Dabei gibt es verschiedene Einstellungen, die Sie bei der Anmeldung f\xFCr Microsoft 365 Tenant beachten sollten, um zu entscheiden, wie SharePoint Online-Websites konfiguriert werden: Der physische Speicherort des SharePoint Online-Rechenzentrums, Land und Region, URL, Administratorkonten und Compliance-Richtlinien.")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"section"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"row center"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col s12 m12"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"/kontakt",className:"btn-large orange darken-4"},"Zur Kontaktanfrage",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"material-icons right",style:{fontSize:"20px"}},"arrow_forward"))))))));}}]);return SharePoint;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["default"] = (SharePoint);

/***/ }),

/***/ 722:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_helmet__ = __webpack_require__(723);
var MetaDecorator=function MetaDecorator(_ref){var title=_ref.title,descrption=_ref.descrption,url=_ref.url,noindex=_ref.noindex;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_helmet__["a" /* Helmet */],null,title?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('title',null,title):"",descrption?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('meta',{name:'description',content:descrption}):"",url?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('link',{rel:'canonical',href:url}):"",noindex?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('meta',{name:'robots',content:'noindex'}):"");};/* harmony default export */ __webpack_exports__["a"] = (MetaDecorator);

/***/ }),

/***/ 723:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HelmetExport; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_side_effect__ = __webpack_require__(724);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_side_effect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_side_effect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_fast_compare__ = __webpack_require__(725);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_fast_compare___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_fast_compare__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_object_assign__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_object_assign__);






var ATTRIBUTE_NAMES = {
    BODY: "bodyAttributes",
    HTML: "htmlAttributes",
    TITLE: "titleAttributes"
};

var TAG_NAMES = {
    BASE: "base",
    BODY: "body",
    HEAD: "head",
    HTML: "html",
    LINK: "link",
    META: "meta",
    NOSCRIPT: "noscript",
    SCRIPT: "script",
    STYLE: "style",
    TITLE: "title"
};

var VALID_TAG_NAMES = Object.keys(TAG_NAMES).map(function (name) {
    return TAG_NAMES[name];
});

var TAG_PROPERTIES = {
    CHARSET: "charset",
    CSS_TEXT: "cssText",
    HREF: "href",
    HTTPEQUIV: "http-equiv",
    INNER_HTML: "innerHTML",
    ITEM_PROP: "itemprop",
    NAME: "name",
    PROPERTY: "property",
    REL: "rel",
    SRC: "src",
    TARGET: "target"
};

var REACT_TAG_MAP = {
    accesskey: "accessKey",
    charset: "charSet",
    class: "className",
    contenteditable: "contentEditable",
    contextmenu: "contextMenu",
    "http-equiv": "httpEquiv",
    itemprop: "itemProp",
    tabindex: "tabIndex"
};

var HELMET_PROPS = {
    DEFAULT_TITLE: "defaultTitle",
    DEFER: "defer",
    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
    TITLE_TEMPLATE: "titleTemplate"
};

var HTML_TAG_MAP = Object.keys(REACT_TAG_MAP).reduce(function (obj, key) {
    obj[REACT_TAG_MAP[key]] = key;
    return obj;
}, {});

var SELF_CLOSING_TAGS = [TAG_NAMES.NOSCRIPT, TAG_NAMES.SCRIPT, TAG_NAMES.STYLE];

var HELMET_ATTRIBUTE = "data-react-helmet";

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};

var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var encodeSpecialCharacters = function encodeSpecialCharacters(str) {
    var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

    if (encode === false) {
        return String(str);
    }

    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
};

var getTitleFromPropsList = function getTitleFromPropsList(propsList) {
    var innermostTitle = getInnermostProperty(propsList, TAG_NAMES.TITLE);
    var innermostTemplate = getInnermostProperty(propsList, HELMET_PROPS.TITLE_TEMPLATE);

    if (innermostTemplate && innermostTitle) {
        // use function arg to avoid need to escape $ characters
        return innermostTemplate.replace(/%s/g, function () {
            return Array.isArray(innermostTitle) ? innermostTitle.join("") : innermostTitle;
        });
    }

    var innermostDefaultTitle = getInnermostProperty(propsList, HELMET_PROPS.DEFAULT_TITLE);

    return innermostTitle || innermostDefaultTitle || undefined;
};

var getOnChangeClientState = function getOnChangeClientState(propsList) {
    return getInnermostProperty(propsList, HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || function () {};
};

var getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
    return propsList.filter(function (props) {
        return typeof props[tagType] !== "undefined";
    }).map(function (props) {
        return props[tagType];
    }).reduce(function (tagAttrs, current) {
        return _extends({}, tagAttrs, current);
    }, {});
};

var getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
    return propsList.filter(function (props) {
        return typeof props[TAG_NAMES.BASE] !== "undefined";
    }).map(function (props) {
        return props[TAG_NAMES.BASE];
    }).reverse().reduce(function (innermostBaseTag, tag) {
        if (!innermostBaseTag.length) {
            var keys = Object.keys(tag);

            for (var i = 0; i < keys.length; i++) {
                var attributeKey = keys[i];
                var lowerCaseAttributeKey = attributeKey.toLowerCase();

                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) {
                    return innermostBaseTag.concat(tag);
                }
            }
        }

        return innermostBaseTag;
    }, []);
};

var getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
    // Calculate list of tags, giving priority innermost component (end of the propslist)
    var approvedSeenTags = {};

    return propsList.filter(function (props) {
        if (Array.isArray(props[tagName])) {
            return true;
        }
        if (typeof props[tagName] !== "undefined") {
            warn("Helmet: " + tagName + " should be of type \"Array\". Instead found type \"" + _typeof(props[tagName]) + "\"");
        }
        return false;
    }).map(function (props) {
        return props[tagName];
    }).reverse().reduce(function (approvedTags, instanceTags) {
        var instanceSeenTags = {};

        instanceTags.filter(function (tag) {
            var primaryAttributeKey = void 0;
            var keys = Object.keys(tag);
            for (var i = 0; i < keys.length; i++) {
                var attributeKey = keys[i];
                var lowerCaseAttributeKey = attributeKey.toLowerCase();

                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) {
                    primaryAttributeKey = lowerCaseAttributeKey;
                }
                // Special case for innerHTML which doesn't work lowercased
                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === TAG_PROPERTIES.INNER_HTML || attributeKey === TAG_PROPERTIES.CSS_TEXT || attributeKey === TAG_PROPERTIES.ITEM_PROP)) {
                    primaryAttributeKey = attributeKey;
                }
            }

            if (!primaryAttributeKey || !tag[primaryAttributeKey]) {
                return false;
            }

            var value = tag[primaryAttributeKey].toLowerCase();

            if (!approvedSeenTags[primaryAttributeKey]) {
                approvedSeenTags[primaryAttributeKey] = {};
            }

            if (!instanceSeenTags[primaryAttributeKey]) {
                instanceSeenTags[primaryAttributeKey] = {};
            }

            if (!approvedSeenTags[primaryAttributeKey][value]) {
                instanceSeenTags[primaryAttributeKey][value] = true;
                return true;
            }

            return false;
        }).reverse().forEach(function (tag) {
            return approvedTags.push(tag);
        });

        // Update seen tags with tags from this instance
        var keys = Object.keys(instanceSeenTags);
        for (var i = 0; i < keys.length; i++) {
            var attributeKey = keys[i];
            var tagUnion = __WEBPACK_IMPORTED_MODULE_4_object_assign___default()({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);

            approvedSeenTags[attributeKey] = tagUnion;
        }

        return approvedTags;
    }, []).reverse();
};

var getInnermostProperty = function getInnermostProperty(propsList, property) {
    for (var i = propsList.length - 1; i >= 0; i--) {
        var props = propsList[i];

        if (props.hasOwnProperty(property)) {
            return props[property];
        }
    }

    return null;
};

var reducePropsToState = function reducePropsToState(propsList) {
    return {
        baseTag: getBaseTagFromPropsList([TAG_PROPERTIES.HREF, TAG_PROPERTIES.TARGET], propsList),
        bodyAttributes: getAttributesFromPropsList(ATTRIBUTE_NAMES.BODY, propsList),
        defer: getInnermostProperty(propsList, HELMET_PROPS.DEFER),
        encode: getInnermostProperty(propsList, HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
        htmlAttributes: getAttributesFromPropsList(ATTRIBUTE_NAMES.HTML, propsList),
        linkTags: getTagsFromPropsList(TAG_NAMES.LINK, [TAG_PROPERTIES.REL, TAG_PROPERTIES.HREF], propsList),
        metaTags: getTagsFromPropsList(TAG_NAMES.META, [TAG_PROPERTIES.NAME, TAG_PROPERTIES.CHARSET, TAG_PROPERTIES.HTTPEQUIV, TAG_PROPERTIES.PROPERTY, TAG_PROPERTIES.ITEM_PROP], propsList),
        noscriptTags: getTagsFromPropsList(TAG_NAMES.NOSCRIPT, [TAG_PROPERTIES.INNER_HTML], propsList),
        onChangeClientState: getOnChangeClientState(propsList),
        scriptTags: getTagsFromPropsList(TAG_NAMES.SCRIPT, [TAG_PROPERTIES.SRC, TAG_PROPERTIES.INNER_HTML], propsList),
        styleTags: getTagsFromPropsList(TAG_NAMES.STYLE, [TAG_PROPERTIES.CSS_TEXT], propsList),
        title: getTitleFromPropsList(propsList),
        titleAttributes: getAttributesFromPropsList(ATTRIBUTE_NAMES.TITLE, propsList)
    };
};

var rafPolyfill = function () {
    var clock = Date.now();

    return function (callback) {
        var currentTime = Date.now();

        if (currentTime - clock > 16) {
            clock = currentTime;
            callback(currentTime);
        } else {
            setTimeout(function () {
                rafPolyfill(callback);
            }, 0);
        }
    };
}();

var cafPolyfill = function cafPolyfill(id) {
    return clearTimeout(id);
};

var requestAnimationFrame = typeof window !== "undefined" ? window.requestAnimationFrame && window.requestAnimationFrame.bind(window) || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || rafPolyfill : global.requestAnimationFrame || rafPolyfill;

var cancelAnimationFrame = typeof window !== "undefined" ? window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || cafPolyfill : global.cancelAnimationFrame || cafPolyfill;

var warn = function warn(msg) {
    return console && typeof console.warn === "function" && console.warn(msg);
};

var _helmetCallback = null;

var handleClientStateChange = function handleClientStateChange(newState) {
    if (_helmetCallback) {
        cancelAnimationFrame(_helmetCallback);
    }

    if (newState.defer) {
        _helmetCallback = requestAnimationFrame(function () {
            commitTagChanges(newState, function () {
                _helmetCallback = null;
            });
        });
    } else {
        commitTagChanges(newState);
        _helmetCallback = null;
    }
};

var commitTagChanges = function commitTagChanges(newState, cb) {
    var baseTag = newState.baseTag,
        bodyAttributes = newState.bodyAttributes,
        htmlAttributes = newState.htmlAttributes,
        linkTags = newState.linkTags,
        metaTags = newState.metaTags,
        noscriptTags = newState.noscriptTags,
        onChangeClientState = newState.onChangeClientState,
        scriptTags = newState.scriptTags,
        styleTags = newState.styleTags,
        title = newState.title,
        titleAttributes = newState.titleAttributes;

    updateAttributes(TAG_NAMES.BODY, bodyAttributes);
    updateAttributes(TAG_NAMES.HTML, htmlAttributes);

    updateTitle(title, titleAttributes);

    var tagUpdates = {
        baseTag: updateTags(TAG_NAMES.BASE, baseTag),
        linkTags: updateTags(TAG_NAMES.LINK, linkTags),
        metaTags: updateTags(TAG_NAMES.META, metaTags),
        noscriptTags: updateTags(TAG_NAMES.NOSCRIPT, noscriptTags),
        scriptTags: updateTags(TAG_NAMES.SCRIPT, scriptTags),
        styleTags: updateTags(TAG_NAMES.STYLE, styleTags)
    };

    var addedTags = {};
    var removedTags = {};

    Object.keys(tagUpdates).forEach(function (tagType) {
        var _tagUpdates$tagType = tagUpdates[tagType],
            newTags = _tagUpdates$tagType.newTags,
            oldTags = _tagUpdates$tagType.oldTags;


        if (newTags.length) {
            addedTags[tagType] = newTags;
        }
        if (oldTags.length) {
            removedTags[tagType] = tagUpdates[tagType].oldTags;
        }
    });

    cb && cb();

    onChangeClientState(newState, addedTags, removedTags);
};

var flattenArray = function flattenArray(possibleArray) {
    return Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
};

var updateTitle = function updateTitle(title, attributes) {
    if (typeof title !== "undefined" && document.title !== title) {
        document.title = flattenArray(title);
    }

    updateAttributes(TAG_NAMES.TITLE, attributes);
};

var updateAttributes = function updateAttributes(tagName, attributes) {
    var elementTag = document.getElementsByTagName(tagName)[0];

    if (!elementTag) {
        return;
    }

    var helmetAttributeString = elementTag.getAttribute(HELMET_ATTRIBUTE);
    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
    var attributesToRemove = [].concat(helmetAttributes);
    var attributeKeys = Object.keys(attributes);

    for (var i = 0; i < attributeKeys.length; i++) {
        var attribute = attributeKeys[i];
        var value = attributes[attribute] || "";

        if (elementTag.getAttribute(attribute) !== value) {
            elementTag.setAttribute(attribute, value);
        }

        if (helmetAttributes.indexOf(attribute) === -1) {
            helmetAttributes.push(attribute);
        }

        var indexToSave = attributesToRemove.indexOf(attribute);
        if (indexToSave !== -1) {
            attributesToRemove.splice(indexToSave, 1);
        }
    }

    for (var _i = attributesToRemove.length - 1; _i >= 0; _i--) {
        elementTag.removeAttribute(attributesToRemove[_i]);
    }

    if (helmetAttributes.length === attributesToRemove.length) {
        elementTag.removeAttribute(HELMET_ATTRIBUTE);
    } else if (elementTag.getAttribute(HELMET_ATTRIBUTE) !== attributeKeys.join(",")) {
        elementTag.setAttribute(HELMET_ATTRIBUTE, attributeKeys.join(","));
    }
};

var updateTags = function updateTags(type, tags) {
    var headElement = document.head || document.querySelector(TAG_NAMES.HEAD);
    var tagNodes = headElement.querySelectorAll(type + "[" + HELMET_ATTRIBUTE + "]");
    var oldTags = Array.prototype.slice.call(tagNodes);
    var newTags = [];
    var indexToDelete = void 0;

    if (tags && tags.length) {
        tags.forEach(function (tag) {
            var newElement = document.createElement(type);

            for (var attribute in tag) {
                if (tag.hasOwnProperty(attribute)) {
                    if (attribute === TAG_PROPERTIES.INNER_HTML) {
                        newElement.innerHTML = tag.innerHTML;
                    } else if (attribute === TAG_PROPERTIES.CSS_TEXT) {
                        if (newElement.styleSheet) {
                            newElement.styleSheet.cssText = tag.cssText;
                        } else {
                            newElement.appendChild(document.createTextNode(tag.cssText));
                        }
                    } else {
                        var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
                        newElement.setAttribute(attribute, value);
                    }
                }
            }

            newElement.setAttribute(HELMET_ATTRIBUTE, "true");

            // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
            if (oldTags.some(function (existingTag, index) {
                indexToDelete = index;
                return newElement.isEqualNode(existingTag);
            })) {
                oldTags.splice(indexToDelete, 1);
            } else {
                newTags.push(newElement);
            }
        });
    }

    oldTags.forEach(function (tag) {
        return tag.parentNode.removeChild(tag);
    });
    newTags.forEach(function (tag) {
        return headElement.appendChild(tag);
    });

    return {
        oldTags: oldTags,
        newTags: newTags
    };
};

var generateElementAttributesAsString = function generateElementAttributesAsString(attributes) {
    return Object.keys(attributes).reduce(function (str, key) {
        var attr = typeof attributes[key] !== "undefined" ? key + "=\"" + attributes[key] + "\"" : "" + key;
        return str ? str + " " + attr : attr;
    }, "");
};

var generateTitleAsString = function generateTitleAsString(type, title, attributes, encode) {
    var attributeString = generateElementAttributesAsString(attributes);
    var flattenedTitle = flattenArray(title);
    return attributeString ? "<" + type + " " + HELMET_ATTRIBUTE + "=\"true\" " + attributeString + ">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">" : "<" + type + " " + HELMET_ATTRIBUTE + "=\"true\">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">";
};

var generateTagsAsString = function generateTagsAsString(type, tags, encode) {
    return tags.reduce(function (str, tag) {
        var attributeHtml = Object.keys(tag).filter(function (attribute) {
            return !(attribute === TAG_PROPERTIES.INNER_HTML || attribute === TAG_PROPERTIES.CSS_TEXT);
        }).reduce(function (string, attribute) {
            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + "=\"" + encodeSpecialCharacters(tag[attribute], encode) + "\"";
            return string ? string + " " + attr : attr;
        }, "");

        var tagContent = tag.innerHTML || tag.cssText || "";

        var isSelfClosing = SELF_CLOSING_TAGS.indexOf(type) === -1;

        return str + "<" + type + " " + HELMET_ATTRIBUTE + "=\"true\" " + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
    }, "");
};

var convertElementAttributestoReactProps = function convertElementAttributestoReactProps(attributes) {
    var initProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    return Object.keys(attributes).reduce(function (obj, key) {
        obj[REACT_TAG_MAP[key] || key] = attributes[key];
        return obj;
    }, initProps);
};

var convertReactPropstoHtmlAttributes = function convertReactPropstoHtmlAttributes(props) {
    var initAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    return Object.keys(props).reduce(function (obj, key) {
        obj[HTML_TAG_MAP[key] || key] = props[key];
        return obj;
    }, initAttributes);
};

var generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
    var _initProps;

    // assigning into an array to define toString function on it
    var initProps = (_initProps = {
        key: title
    }, _initProps[HELMET_ATTRIBUTE] = true, _initProps);
    var props = convertElementAttributestoReactProps(attributes, initProps);

    return [__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(TAG_NAMES.TITLE, props, title)];
};

var generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
    return tags.map(function (tag, i) {
        var _mappedTag;

        var mappedTag = (_mappedTag = {
            key: i
        }, _mappedTag[HELMET_ATTRIBUTE] = true, _mappedTag);

        Object.keys(tag).forEach(function (attribute) {
            var mappedAttribute = REACT_TAG_MAP[attribute] || attribute;

            if (mappedAttribute === TAG_PROPERTIES.INNER_HTML || mappedAttribute === TAG_PROPERTIES.CSS_TEXT) {
                var content = tag.innerHTML || tag.cssText;
                mappedTag.dangerouslySetInnerHTML = { __html: content };
            } else {
                mappedTag[mappedAttribute] = tag[attribute];
            }
        });

        return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(type, mappedTag);
    });
};

var getMethodsForTag = function getMethodsForTag(type, tags, encode) {
    switch (type) {
        case TAG_NAMES.TITLE:
            return {
                toComponent: function toComponent() {
                    return generateTitleAsReactComponent(type, tags.title, tags.titleAttributes, encode);
                },
                toString: function toString() {
                    return generateTitleAsString(type, tags.title, tags.titleAttributes, encode);
                }
            };
        case ATTRIBUTE_NAMES.BODY:
        case ATTRIBUTE_NAMES.HTML:
            return {
                toComponent: function toComponent() {
                    return convertElementAttributestoReactProps(tags);
                },
                toString: function toString() {
                    return generateElementAttributesAsString(tags);
                }
            };
        default:
            return {
                toComponent: function toComponent() {
                    return generateTagsAsReactComponent(type, tags);
                },
                toString: function toString() {
                    return generateTagsAsString(type, tags, encode);
                }
            };
    }
};

var mapStateOnServer = function mapStateOnServer(_ref) {
    var baseTag = _ref.baseTag,
        bodyAttributes = _ref.bodyAttributes,
        encode = _ref.encode,
        htmlAttributes = _ref.htmlAttributes,
        linkTags = _ref.linkTags,
        metaTags = _ref.metaTags,
        noscriptTags = _ref.noscriptTags,
        scriptTags = _ref.scriptTags,
        styleTags = _ref.styleTags,
        _ref$title = _ref.title,
        title = _ref$title === undefined ? "" : _ref$title,
        titleAttributes = _ref.titleAttributes;
    return {
        base: getMethodsForTag(TAG_NAMES.BASE, baseTag, encode),
        bodyAttributes: getMethodsForTag(ATTRIBUTE_NAMES.BODY, bodyAttributes, encode),
        htmlAttributes: getMethodsForTag(ATTRIBUTE_NAMES.HTML, htmlAttributes, encode),
        link: getMethodsForTag(TAG_NAMES.LINK, linkTags, encode),
        meta: getMethodsForTag(TAG_NAMES.META, metaTags, encode),
        noscript: getMethodsForTag(TAG_NAMES.NOSCRIPT, noscriptTags, encode),
        script: getMethodsForTag(TAG_NAMES.SCRIPT, scriptTags, encode),
        style: getMethodsForTag(TAG_NAMES.STYLE, styleTags, encode),
        title: getMethodsForTag(TAG_NAMES.TITLE, { title: title, titleAttributes: titleAttributes }, encode)
    };
};

var Helmet = function Helmet(Component) {
    var _class, _temp;

    return _temp = _class = function (_React$Component) {
        inherits(HelmetWrapper, _React$Component);

        function HelmetWrapper() {
            classCallCheck(this, HelmetWrapper);
            return possibleConstructorReturn(this, _React$Component.apply(this, arguments));
        }

        HelmetWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
            return !__WEBPACK_IMPORTED_MODULE_2_react_fast_compare___default()(this.props, nextProps);
        };

        HelmetWrapper.prototype.mapNestedChildrenToProps = function mapNestedChildrenToProps(child, nestedChildren) {
            if (!nestedChildren) {
                return null;
            }

            switch (child.type) {
                case TAG_NAMES.SCRIPT:
                case TAG_NAMES.NOSCRIPT:
                    return {
                        innerHTML: nestedChildren
                    };

                case TAG_NAMES.STYLE:
                    return {
                        cssText: nestedChildren
                    };
            }

            throw new Error("<" + child.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
        };

        HelmetWrapper.prototype.flattenArrayTypeChildren = function flattenArrayTypeChildren(_ref) {
            var _babelHelpers$extends;

            var child = _ref.child,
                arrayTypeChildren = _ref.arrayTypeChildren,
                newChildProps = _ref.newChildProps,
                nestedChildren = _ref.nestedChildren;

            return _extends({}, arrayTypeChildren, (_babelHelpers$extends = {}, _babelHelpers$extends[child.type] = [].concat(arrayTypeChildren[child.type] || [], [_extends({}, newChildProps, this.mapNestedChildrenToProps(child, nestedChildren))]), _babelHelpers$extends));
        };

        HelmetWrapper.prototype.mapObjectTypeChildren = function mapObjectTypeChildren(_ref2) {
            var _babelHelpers$extends2, _babelHelpers$extends3;

            var child = _ref2.child,
                newProps = _ref2.newProps,
                newChildProps = _ref2.newChildProps,
                nestedChildren = _ref2.nestedChildren;

            switch (child.type) {
                case TAG_NAMES.TITLE:
                    return _extends({}, newProps, (_babelHelpers$extends2 = {}, _babelHelpers$extends2[child.type] = nestedChildren, _babelHelpers$extends2.titleAttributes = _extends({}, newChildProps), _babelHelpers$extends2));

                case TAG_NAMES.BODY:
                    return _extends({}, newProps, {
                        bodyAttributes: _extends({}, newChildProps)
                    });

                case TAG_NAMES.HTML:
                    return _extends({}, newProps, {
                        htmlAttributes: _extends({}, newChildProps)
                    });
            }

            return _extends({}, newProps, (_babelHelpers$extends3 = {}, _babelHelpers$extends3[child.type] = _extends({}, newChildProps), _babelHelpers$extends3));
        };

        HelmetWrapper.prototype.mapArrayTypeChildrenToProps = function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
            var newFlattenedProps = _extends({}, newProps);

            Object.keys(arrayTypeChildren).forEach(function (arrayChildName) {
                var _babelHelpers$extends4;

                newFlattenedProps = _extends({}, newFlattenedProps, (_babelHelpers$extends4 = {}, _babelHelpers$extends4[arrayChildName] = arrayTypeChildren[arrayChildName], _babelHelpers$extends4));
            });

            return newFlattenedProps;
        };

        HelmetWrapper.prototype.warnOnInvalidChildren = function warnOnInvalidChildren(child, nestedChildren) {
            if (false) {
                if (!VALID_TAG_NAMES.some(function (name) {
                    return child.type === name;
                })) {
                    if (typeof child.type === "function") {
                        return warn("You may be attempting to nest <Helmet> components within each other, which is not allowed. Refer to our API for more information.");
                    }

                    return warn("Only elements types " + VALID_TAG_NAMES.join(", ") + " are allowed. Helmet does not support rendering <" + child.type + "> elements. Refer to our API for more information.");
                }

                if (nestedChildren && typeof nestedChildren !== "string" && (!Array.isArray(nestedChildren) || nestedChildren.some(function (nestedChild) {
                    return typeof nestedChild !== "string";
                }))) {
                    throw new Error("Helmet expects a string as a child of <" + child.type + ">. Did you forget to wrap your children in braces? ( <" + child.type + ">{``}</" + child.type + "> ) Refer to our API for more information.");
                }
            }

            return true;
        };

        HelmetWrapper.prototype.mapChildrenToProps = function mapChildrenToProps(children, newProps) {
            var _this2 = this;

            var arrayTypeChildren = {};

            __WEBPACK_IMPORTED_MODULE_3_react___default.a.Children.forEach(children, function (child) {
                if (!child || !child.props) {
                    return;
                }

                var _child$props = child.props,
                    nestedChildren = _child$props.children,
                    childProps = objectWithoutProperties(_child$props, ["children"]);

                var newChildProps = convertReactPropstoHtmlAttributes(childProps);

                _this2.warnOnInvalidChildren(child, nestedChildren);

                switch (child.type) {
                    case TAG_NAMES.LINK:
                    case TAG_NAMES.META:
                    case TAG_NAMES.NOSCRIPT:
                    case TAG_NAMES.SCRIPT:
                    case TAG_NAMES.STYLE:
                        arrayTypeChildren = _this2.flattenArrayTypeChildren({
                            child: child,
                            arrayTypeChildren: arrayTypeChildren,
                            newChildProps: newChildProps,
                            nestedChildren: nestedChildren
                        });
                        break;

                    default:
                        newProps = _this2.mapObjectTypeChildren({
                            child: child,
                            newProps: newProps,
                            newChildProps: newChildProps,
                            nestedChildren: nestedChildren
                        });
                        break;
                }
            });

            newProps = this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
            return newProps;
        };

        HelmetWrapper.prototype.render = function render() {
            var _props = this.props,
                children = _props.children,
                props = objectWithoutProperties(_props, ["children"]);

            var newProps = _extends({}, props);

            if (children) {
                newProps = this.mapChildrenToProps(children, newProps);
            }

            return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Component, newProps);
        };

        createClass(HelmetWrapper, null, [{
            key: "canUseDOM",


            // Component.peek comes from react-side-effect:
            // For testing, you may use a static peek() method available on the returned component.
            // It lets you get the current state without resetting the mounted instance stack.
            // Don’t use it for anything other than testing.

            /**
             * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
             * @param {Object} bodyAttributes: {"className": "root"}
             * @param {String} defaultTitle: "Default Title"
             * @param {Boolean} defer: true
             * @param {Boolean} encodeSpecialCharacters: true
             * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
             * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
             * @param {Array} meta: [{"name": "description", "content": "Test description"}]
             * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
             * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
             * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
             * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
             * @param {String} title: "Title"
             * @param {Object} titleAttributes: {"itemprop": "name"}
             * @param {String} titleTemplate: "MySite.com - %s"
             */
            set: function set$$1(canUseDOM) {
                Component.canUseDOM = canUseDOM;
            }
        }]);
        return HelmetWrapper;
    }(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component), _class.propTypes = {
        base: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object,
        bodyAttributes: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object,
        children: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.node), __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.node]),
        defaultTitle: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
        defer: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
        encodeSpecialCharacters: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
        htmlAttributes: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object,
        link: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object),
        meta: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object),
        noscript: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object),
        onChangeClientState: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
        script: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object),
        style: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object),
        title: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
        titleAttributes: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object,
        titleTemplate: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string
    }, _class.defaultProps = {
        defer: true,
        encodeSpecialCharacters: true
    }, _class.peek = Component.peek, _class.rewind = function () {
        var mappedState = Component.rewind();
        if (!mappedState) {
            // provide fallback if mappedState is undefined
            mappedState = mapStateOnServer({
                baseTag: [],
                bodyAttributes: {},
                encodeSpecialCharacters: true,
                htmlAttributes: {},
                linkTags: [],
                metaTags: [],
                noscriptTags: [],
                scriptTags: [],
                styleTags: [],
                title: "",
                titleAttributes: {}
            });
        }

        return mappedState;
    }, _temp;
};

var NullComponent = function NullComponent() {
    return null;
};

var HelmetSideEffects = __WEBPACK_IMPORTED_MODULE_1_react_side_effect___default()(reducePropsToState, handleClientStateChange, mapStateOnServer)(NullComponent);

var HelmetExport = Helmet(HelmetSideEffects);
HelmetExport.renderStatic = HelmetExport.rewind;

/* unused harmony default export */ var _unused_webpack_default_export = (HelmetExport);


/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(81)))

/***/ }),

/***/ 724:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = __webpack_require__(15);
var React__default = _interopDefault(React);

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
  if (typeof reducePropsToState !== 'function') {
    throw new Error('Expected reducePropsToState to be a function.');
  }

  if (typeof handleStateChangeOnClient !== 'function') {
    throw new Error('Expected handleStateChangeOnClient to be a function.');
  }

  if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') {
    throw new Error('Expected mapStateOnServer to either be undefined or a function.');
  }

  function getDisplayName(WrappedComponent) {
    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
  }

  return function wrap(WrappedComponent) {
    if (typeof WrappedComponent !== 'function') {
      throw new Error('Expected WrappedComponent to be a React component.');
    }

    var mountedInstances = [];
    var state;

    function emitChange() {
      state = reducePropsToState(mountedInstances.map(function (instance) {
        return instance.props;
      }));

      if (SideEffect.canUseDOM) {
        handleStateChangeOnClient(state);
      } else if (mapStateOnServer) {
        state = mapStateOnServer(state);
      }
    }

    var SideEffect = /*#__PURE__*/function (_PureComponent) {
      _inheritsLoose(SideEffect, _PureComponent);

      function SideEffect() {
        return _PureComponent.apply(this, arguments) || this;
      }

      // Try to use displayName of wrapped component
      // Expose canUseDOM so tests can monkeypatch it
      SideEffect.peek = function peek() {
        return state;
      };

      SideEffect.rewind = function rewind() {
        if (SideEffect.canUseDOM) {
          throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
        }

        var recordedState = state;
        state = undefined;
        mountedInstances = [];
        return recordedState;
      };

      var _proto = SideEffect.prototype;

      _proto.UNSAFE_componentWillMount = function UNSAFE_componentWillMount() {
        mountedInstances.push(this);
        emitChange();
      };

      _proto.componentDidUpdate = function componentDidUpdate() {
        emitChange();
      };

      _proto.componentWillUnmount = function componentWillUnmount() {
        var index = mountedInstances.indexOf(this);
        mountedInstances.splice(index, 1);
        emitChange();
      };

      _proto.render = function render() {
        return /*#__PURE__*/React__default.createElement(WrappedComponent, this.props);
      };

      return SideEffect;
    }(React.PureComponent);

    _defineProperty(SideEffect, "displayName", "SideEffect(" + getDisplayName(WrappedComponent) + ")");

    _defineProperty(SideEffect, "canUseDOM", canUseDOM);

    return SideEffect;
  };
}

module.exports = withSideEffect;


/***/ }),

/***/ 725:
/***/ (function(module, exports) {

/* global Map:readonly, Set:readonly, ArrayBuffer:readonly */

var hasElementType = typeof Element !== 'undefined';
var hasMap = typeof Map === 'function';
var hasSet = typeof Set === 'function';
var hasArrayBuffer = typeof ArrayBuffer === 'function' && !!ArrayBuffer.isView;

// Note: We **don't** need `envHasBigInt64Array` in fde es6/index.js

function equal(a, b) {
  // START: fast-deep-equal es6/index.js 3.1.1
  if (a === b) return true;

  if (a && b && typeof a == 'object' && typeof b == 'object') {
    if (a.constructor !== b.constructor) return false;

    var length, i, keys;
    if (Array.isArray(a)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (!equal(a[i], b[i])) return false;
      return true;
    }

    // START: Modifications:
    // 1. Extra `has<Type> &&` helpers in initial condition allow es6 code
    //    to co-exist with es5.
    // 2. Replace `for of` with es5 compliant iteration using `for`.
    //    Basically, take:
    //
    //    ```js
    //    for (i of a.entries())
    //      if (!b.has(i[0])) return false;
    //    ```
    //
    //    ... and convert to:
    //
    //    ```js
    //    it = a.entries();
    //    while (!(i = it.next()).done)
    //      if (!b.has(i.value[0])) return false;
    //    ```
    //
    //    **Note**: `i` access switches to `i.value`.
    var it;
    if (hasMap && (a instanceof Map) && (b instanceof Map)) {
      if (a.size !== b.size) return false;
      it = a.entries();
      while (!(i = it.next()).done)
        if (!b.has(i.value[0])) return false;
      it = a.entries();
      while (!(i = it.next()).done)
        if (!equal(i.value[1], b.get(i.value[0]))) return false;
      return true;
    }

    if (hasSet && (a instanceof Set) && (b instanceof Set)) {
      if (a.size !== b.size) return false;
      it = a.entries();
      while (!(i = it.next()).done)
        if (!b.has(i.value[0])) return false;
      return true;
    }
    // END: Modifications

    if (hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (a[i] !== b[i]) return false;
      return true;
    }

    if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
    if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
    if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();

    keys = Object.keys(a);
    length = keys.length;
    if (length !== Object.keys(b).length) return false;

    for (i = length; i-- !== 0;)
      if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
    // END: fast-deep-equal

    // START: react-fast-compare
    // custom handling for DOM elements
    if (hasElementType && a instanceof Element) return false;

    // custom handling for React/Preact
    for (i = length; i-- !== 0;) {
      if ((keys[i] === '_owner' || keys[i] === '__v' || keys[i] === '__o') && a.$$typeof) {
        // React-specific: avoid traversing React elements' _owner
        // Preact-specific: avoid traversing Preact elements' __v and __o
        //    __v = $_original / $_vnode
        //    __o = $_owner
        // These properties contain circular references and are not needed when
        // comparing the actual elements (and not their owners)
        // .$$typeof and ._store on just reasonable markers of elements

        continue;
      }

      // all other properties should be traversed as usual
      if (!equal(a[keys[i]], b[keys[i]])) return false;
    }
    // END: react-fast-compare

    // START: fast-deep-equal
    return true;
  }

  return a !== a && b !== b;
}
// end fast-deep-equal

module.exports = function isEqual(a, b) {
  try {
    return equal(a, b);
  } catch (error) {
    if (((error.message || '').match(/stack|recursion/i))) {
      // warn on circular references, don't crash
      // browsers give this different errors name and messages:
      // chrome/safari: "RangeError", "Maximum call stack size exceeded"
      // firefox: "InternalError", too much recursion"
      // edge: "Error", "Out of stack space"
      console.warn('react-fast-compare cannot handle circular refs');
      return false;
    }
    // some other error. we should definitely know about these
    throw error;
  }
};


/***/ }),

/***/ 878:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/sharepoint.85bebe54.jpg";

/***/ }),

/***/ 879:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/sharepointMobile.efc51d70.jpg";

/***/ })

});


// WEBPACK FOOTER //
// static/js/15.95d59d3f.chunk.js